import React, { Component } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";

import Home from "./containers/Home";
import About from "./containers/About";
import Login from "./containers/Login";
import Dashboard from "./containers/Dashboard";
import SubmitListings from "./containers/SubmitListings";
import Confirmation from "./containers/Confirmation";
import Registration from "./containers/Registration";
import TermsAndConditions from "./containers/TermsAndConditions";
import PrivacyPolicy from "./containers/PrivacyPolicy";
import Faq from "./containers/Faq";
import Verification from "./containers/Verification";

function PrivateRoute({
  component: Component,
  isLoggedIn,
  toggleIsLoggedIn,
  user,
  path,
  ...rest
}) {
  return (
    <Route
      {...rest}
      render={(props) =>
        isLoggedIn === true ? (
          <Component
            user={user}
            isLoggedIn={isLoggedIn}
            toggleIsLoggedIn={toggleIsLoggedIn}
            {...props}
          />
        ) : (
          <Redirect to={{ pathname: "/login", state: { from: { path } } }} />
        )
      }
    />
  );
}

function RouteExtended({
  component: Component,
  isLoggedIn,
  toggleIsLoggedIn,
  user,
  path,
  ...rest
}) {
  return (
    <Route
      {...rest}
      render={(props) => (
        <Component
          user={user}
          isLoggedIn={isLoggedIn}
          toggleIsLoggedIn={toggleIsLoggedIn}
          {...props}
        />
      )}
    />
  );
}

class App extends Component {
  constructor() {
    super();
    this.state = {
      isLoggedIn: false,
      submitSuccess: false,

      user: {
        user_id: "",
        username: "",
        account_type: "", // admin, brand, agent
      },

      access_token: "",
    };
  }

  toggleIsLoggedIn() {
    this.setState({ isLoggedIn: !this.state.isLoggedIn });
  }

  getUserData(user, access_token) {
    this.setState({ user: user, access_token: access_token });
  }

  getSubmitStatus(status) {
    this.setState({ submitSuccess: status });
  }

  checkLoginState() {
    // Check if this.state.isLoggedIn === true && currentRoute === ???
  }

  render() {
    return (
      <Router>
        <Switch>
          <RouteExtended
            path="/"
            exact
            isLoggedIn={this.state.isLoggedIn}
            toggleIsLoggedIn={this.toggleIsLoggedIn.bind(this)}
            component={Home}
          />
          <RouteExtended
            path="/about"
            exact
            isLoggedIn={this.state.isLoggedIn}
            toggleIsLoggedIn={this.toggleIsLoggedIn.bind(this)}
            component={About}
          />
          <RouteExtended
            path="/terms"
            exact
            isLoggedIn={this.state.isLoggedIn}
            toggleIsLoggedIn={this.toggleIsLoggedIn.bind(this)}
            component={TermsAndConditions}
          />
          <RouteExtended
            path="/privacy"
            exact
            isLoggedIn={this.state.isLoggedIn}
            toggleIsLoggedIn={this.toggleIsLoggedIn.bind(this)}
            component={PrivacyPolicy}
          />
          <RouteExtended
            path="/faq"
            exact
            isLoggedIn={this.state.isLoggedIn}
            toggleIsLoggedIn={this.toggleIsLoggedIn.bind(this)}
            component={Faq}
          />
          <RouteExtended
            path="/verify/_id=:id/type=:type"
            component={Verification}
          />
          <Route
            path="/login"
            exact
            render={() => (
              <Login
                isLoggedIn={this.state.isLoggedIn}
                toggleIsLoggedIn={this.toggleIsLoggedIn.bind(this)}
                getUserData={this.getUserData.bind(this)}
              />
            )}
          />

          <Route path="/confirmation" exact component={Confirmation} />
          <PrivateRoute
            user={this.state.user}
            getSubmitStatus={this.getSubmitStatus.bind(this)}
            isLoggedIn={this.state.isLoggedIn}
            path="/submitlistings"
            component={SubmitListings}
            toggleIsLoggedIn={this.toggleIsLoggedIn.bind(this)}
          />
          <PrivateRoute
            user={this.state.user}
            isLoggedIn={this.state.isLoggedIn}
            toggleIsLoggedIn={this.toggleIsLoggedIn.bind(this)}
            path="/admin"
            component={Dashboard}
          />
          <RouteExtended
            path="/register"
            exact
            isLoggedIn={this.state.isLoggedIn}
            toggleIsLoggedIn={this.toggleIsLoggedIn.bind(this)}
            component={Registration}
          />

          <RouteExtended
            isLoggedIn={this.state.isLoggedIn}
            toggleIsLoggedIn={this.toggleIsLoggedIn.bind(this)}
            component={Home}
          />
        </Switch>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js